import React, {useMemo, useEffect, useState} from "react";

//components
import GeneralCardWithoutImage from "../GeneralCardWithoutImage";



function useIsMobile() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 1100);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return isMobile;
}

function textField(title, description, footer, isMobile, id) {
    return (
        <>
      <div className="d-flex justify-content-center" style={{ marginTop: "20px" }} key={id}>
        <div className="card mb-3" style={{ maxWidth: isMobile ? "80%" : "30%" }}>
          <div className="row g-0">
            <div className="card-body">
                <h5 className="card-title">{title}</h5>
                <p className="card-text">{description}</p>
                <p className="card-text"><small className="text-muted">{footer}</small></p>
            </div>
          </div>
        </div>
      </div>
    </>
    )
}
function sliderField(title, description, maximum, minimum, isMobile, id) {
    const sliderValue = 0; //NOT DYNAMIC YET, WILL BE LATER FIXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
    return (
        <>
      <div className="d-flex justify-content-center" style={{ marginTop: "20px" }} key={id}>
        <div className="card mb-3" style={{ maxWidth: isMobile ? "80%" : "30%" }}>
          <div className="row g-0">
            <div className="card-body">
                <h5 className="card-title">{title}</h5>
                <p className="card-text">{description}</p>
                <input type="range" min={minimum} max={maximum} className="form-range" value={sliderValue} />
                <p className="card-text" style={{margin: "auto", textAlign: "center"}}><small className="text-muted">{sliderValue}</small></p>
            </div>
          </div>
        </div>
      </div>
    </>
    )
}



function JsonToJSX({InputJSON, editMode}) {

    const [answers, setAnswers] = useState([]);
    const parsedJSON = typeof InputJSON === "string" ? JSON.parse(InputJSON) : InputJSON;
    const isMobile = useIsMobile();


    const handleAnswerChange = (fieldId, value) => {
        setAnswers(prevAnswers => {
            const updatedAnswers = [...prevAnswers];
            updatedAnswers[fieldId] = value;
            return updatedAnswers;
        });
    }


return (
    <>
        <br />
        <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
            <hr class="my-2" />
            <h3>503rd Battalion</h3>
            <h1>{parsedJSON.name}</h1>
            <hr class="my-4" />
        </div>
        <br />
        {parsedJSON.fields?.map((field, index) => {
                switch (field.type) {
                    case "textField":
                        return textField(field.title, field.description, field.footer, isMobile, field.id);
                    case "sliderField":
                        return sliderField(field.title, field.description, field.maximum, field.minimum, isMobile, field.id);
                       

                    case "checkboxField":
                        return (
                            <div key={index}>
                                <h4>{field.title}</h4>
                                {field.options?.map((option, i) => (
                                    <label key={i}>
                                        <input type="checkbox" /> {option}
                                    </label>
                                ))}
                            </div>
                        );
                    case "radioField":
                        return (
                            <div key={index}>
                                <h4>{field.title}</h4>
                                {field.options?.map((option, i) => (
                                    <label key={i}>
                                        <input type="radio" name={field.name} /> {option}
                                    </label>
                                ))}
                            </div>
                    );
                    

                    default:
                        return null;
                }
            })}
    </>
  );
}

export default JsonToJSX;
